import React from 'react';

import { I18n } from '@aws-amplify/core';
import { WarningOutlined } from '@ant-design/icons';

import { WORK_ORGANIZATION_OPTIONS } from '@/components/views/Report/KimLhc/Constants';
import { getWarningIconColor } from '../../../../utils/helper';
import { KimLhcCategoryKey, type WorkOrganizationCategory } from '@/types';


import * as S from '@/components/views/Report/KimLhc/Report/Steps/Result/styles';

interface WorkOrganizationCategoryProps {
	data: WorkOrganizationCategory;
}

export function WorkOrganizationCategory({ data }: Readonly<WorkOrganizationCategoryProps>): JSX.Element {
	const option = WORK_ORGANIZATION_OPTIONS.temporal_distribution.find((o) => o.value === data.value);
	
	const warningIconColor = getWarningIconColor(KimLhcCategoryKey.WORK_ORGANIZATION, data.value);

	if (!option) {
		return (
			<S.AccordionContent>
				<S.EmptyText>{I18n.get('No work organization data available')}</S.EmptyText>
			</S.AccordionContent>
		);
	}

	return (
		<S.AccordionContent>
			<S.FactorItem>
				<S.WarningIcon>
					<WarningOutlined style={{ color: warningIconColor }} />
				</S.WarningIcon>
				<S.FactorText>
					<strong>{I18n.get(option.titleKey)}: </strong>
					{I18n.get(option.descriptionKey)}
				</S.FactorText>
			</S.FactorItem>
		</S.AccordionContent>
	);
}
